import Image1 from '../assets/img/ServiceDescription/1.jpg';
import Image2 from '../assets/img/ServiceDescription/2.jpg';
import Image3 from '../assets/img/ServiceDescription/3.jpg';
import Image4 from '../assets/img/ServiceDescription/4.jpg';
import Image5 from '../assets/img/ServiceDescription/5.jpg';
import Image6 from '../assets/img/ServiceDescription/6.jpg';
import Image7 from '../assets/img/ServiceDescription/7.jpg';
import Image8 from '../assets/img/ServiceDescription/8.jpg';
import Image9 from '../assets/img/ServiceDescription/9.jpg';

const dataServiceDescription = [
    {
        id: 1,
        url: '/projekte/fassaden-hauses',
        image: Image1,
        title: 'STUCK UND FASSADEN',
        descriptionTitle: 'Installation von Fassade und Zierstein. Installation der Demit-Fassade, Abschlussarbeiten an der Fassade.',
        descriptionText: 'Die Außenseite des Hauses wird nach Ihren Wünschen mit Stuck oder mit Putz verarbeitet. Das erste Erscheinungsbild eines Gebäudes ist am wichtigsten.'
    },
    {
        id: 2,
        url: '/projekte/akustikdecken',
        image: Image4,
        title: 'TROCKENBAU UND AKUSTIKDECKEN',
        descriptionTitle: 'Wir können Ihren Raum mit Trockenbautechnik nach Ihren Wünschen aufteilen. Fast sämtliche Anforderungen an den Brand-, Wärme-und Schallschutz kann man mit Trockenbau, sofern man diese nach den technischen Vorschriften einbaut, erfüllen',
        descriptionText: 'In einfachster Weise sind Gewölbe, geschwungene Formen und mehrfach DECKEN gekantete Verkofferungen mit dem modernen Trockenbau möglich. Akustikdecken kombinieren hohe Schall- Längsdämmung mit hohen Absorptionswerten und das bei den oft gewünschten glatten Oberflächen.Vor allem durch die differenzierten akustischen Eigenschaften werden die akustischen Anforderungen an unterschiedlichste Räume optimal erfüllt.',
        descriptionText1: 'Zudem sind Segeldecken ein besonderes Element, welches dem Raum ein schönes Erscheinungsbild ermöglichen.Auf Wunsch lässt sich in die Segeldecke eine LED- Beleuchtung einarbeiten.',
    },
    {
        id: 3,
        // url: '',
        image: Image2,
        title: 'RESTAURATOREN',
        descriptionTitle: 'Das Projekt der Modernisierung des geerbten Hauses und seiner Renovierung ist eine Aufgabe, die ein beneidenswertes Maß an Sorgfalt und Genialität erfordert… ',
        descriptionText: '…die Straßenfassade jedes historischen Hauses muss erhalten bleiben, während die Innenräume einer vollständigen Umgestaltung bedürfen, die hauptsächlich zu ihrer Erfrischung und Zweckmäßigkeit führt. '
    },
    {
        id: 4,
        url: '/projekte/modernes-badezimmer',
        image: Image3,
        title: 'FLIESENARBEITEN',
        descriptionTitle: 'In kürzester Zeit ein neues Badezimmer bauen und ein altes renovieren, unter Verwendung von Material höchster Qualität.',
        descriptionText: 'Wir verlegen mit viel Liebe zum Detail fachgerecht Fliesen im Innenbereich und Außenbereich und übernehmen jegliche Untergrundarbeiten und Vorbereitungsarbeiten.'
    },
    {
        id: 5,
        url: '/projekte/zusammenklappbares-glassystem',
        image: Image7,
        title: 'VESKOVIC PERGOLA',
        descriptionTitle: 'VESKOVIC PERGOLA ist eine Pergola-Produktionsfirma, die gegründet wurde, um Lebensräume im Freien zu schaffen.',
        descriptionText: 'Es bietet seinen Kunden erstklassige Lösungen für das Leben im Freien. Unsere faltbaren Pergola- Systeme bieten einen breiten und flexiblen. Einsatz durch die Integration von Reißverschlussvorhängen, Glasscheibensystemen, LED-Beleuchtungen sowie Guillotine - Glassystemen.',
        descriptionText1: 'Eines der modernsten und praktischen Sonnen-und Niederschlagsschutzsystemen.Aufgrund seiner Eigenschaften und seines Prestige- Aussehen ist er eines der verbreiteten Schutzsysteme gegen äußere Einflüsse in den Gärten von Restaurants und Cafes, sowie auf den Terassen Ihrer Häuser geworden.',
    },
    {
        id: 7,
        url: '/projekte/innenraum-des-hauses',
        image: Image5,
        title: 'INNENRAUM DES HAUSES',
        descriptionTitle: 'Unsere Innenarchitekten arbeiten hart daran, schöne Räume zu schaffen.',
        descriptionText: 'Gestaltung aller Arten von Innenräumen für Ihre Wohnung, Ihr Haus, und Ihren Geschäftsraum. 3D-Modelle für jeden Raum, Möbelmodellierung, Visualisierung und Renderings.'
    },
    {
        id: 6,
        url: '/projekte/poolbau',
        image: Image8,
        title: 'POOL BAU',
        descriptionTitle: 'Das Unternehmen, das sich mit dem Verkauf und Bau verschiedener Gebäude, der Verbesserung und Weiterentwicklung der Technologie befasst, konzentrierte sich zunehmend auf Schwimmbäder und Poolausrüstung.',
        descriptionText: 'Wenn Sie nicht feststellen können, welche Art von Pool Sie benötigen, bieten wir Ihnen umfassende Beratungsunterstützung und helfen Ihnen bei der Auswahl der besten Option. Bei der Arbeit halten wir uns strikt an die Anforderungen des Kunden und die in dieser Branche geltenden Qualitätsstandards. Mit den Diensten von «Stuck Veskovic» erzielen Sie mit Sicherheit ein hohes Leistungsniveau.'
    },
    {
        id: 8,
        url: '/projekte/Wochenend-haus',
        image: Image9,
        title: 'WOCHENENDHAUS',
        descriptionTitle: 'Ferienhäuser aus Holz bauen, Ferienhaus-Bausätze oder Wochenendhäuser - wir erfüllen Ihren Traum vom eigenen Ferienhaus!',
        descriptionText: 'Viele Menschen wohnen in dicht besiedelten Ballungsräumen und Städten, um die unverzichtbare Infrastruktur wie Arbeitsplatz, Schule und Kindergarten in Anspruch zu nehmen. Als ideale Lösung für ein Ausweichquartier in ländlicher Landschaft und natürlicher Umgebung ist das Wochenendhaus bauen ein beliebtes Ziel. '
    },
    {
        id: 9,
        // url: '',
        image: Image6,
        title: 'LANDSCHAFTS UND GARTEN DESIGN',
        descriptionTitle: 'Möchten Sie, dass Ihr Zuhause zu einer friedlichen Oase wird, weiche zum Entspannen und zum Genießen einlädt?',
        descriptionText: 'Egal wie einzigartig und kreativ Ihre Vision für die Landschaftsgestaltung war, wir sind hier, um Sie zu einer realisierten Erweiterung Ihres Hauses zu machen. Um einen Raum zu schaffen, der sich mit der Natur verbindet und Ihre Lebensweise widerspiegelt, integrieren unsere Designer die Architektur Ihres Hauses in die funktionalen und ästhetischen Anforderungen des neuen Hofs.'
    },
]

export default dataServiceDescription
